var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}]},[_c('span',{staticClass:"layuicheck"},[_vm._t("default")],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.enabled),expression:"!enabled"}]},[_c('span',{staticClass:"layuicheck-disabled"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4c23a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LayuiSwitch.vue
// module id = null
// module chunks = 